export class MemberTagConstant {
  static readonly MOBIL = 'mobil';
  static readonly GRUNNKURS = 'grunnkurs';
  static readonly FOTOSKOLEN = 'fotoskolen';
  static readonly FG = 'fg';
}
